class FilterParams {
  constructor({
    propertyTypeIds = null,
    bhkTypeIds = null,
    constructionStatusIds = null,
    furnishingTypeIds = null,
    PGisFor = null,
    BestSuitedFor = null,
    cityIds = null,
    localityIds = null,
    areaIds = null,
    societyIds = null,
    societyAmenities = null,
    propertyAmenities = null,
    budgetFrom = null,
    budgetTo = null,
    propertyType = null,
    vertical = null,
    featured = null,
    my = null,
    status = null,
    postedBy = null,
    MinPrice = null,
    MaxPrice = null,
    wishlist = false

  } = {}) {
    this.propertyTypeIds = propertyTypeIds;
    this.bhkTypeIds = bhkTypeIds;
    this.constructionStatusIds = constructionStatusIds;
    this.furnishingTypeIds = furnishingTypeIds;
    this.PGisFor = PGisFor;
    this.BestSuitedFor = BestSuitedFor;
    this.cityIds = cityIds;
    this.localityIds = localityIds;
    this.areaIds = areaIds;
    this.societyIds = societyIds;
    this.societyAmenities = societyAmenities;
    this.propertyAmenities = propertyAmenities;
    this.budgetFrom = budgetFrom;
    this.budgetTo = budgetTo;
    this.propertyType = propertyType;
    this.vertical = vertical;
    this.featured = featured;
    this.my = my;
    this.status = status;
    this.postedBy = postedBy;
    this.MinPrice = MinPrice;
    this.MaxPrice = MaxPrice;
    this.wishlist = wishlist
  }
}

export default FilterParams;
